import { SET_CHOOSEN_MAP_MODE } from 'src/app/redux/redux-types';
import { reduxSettingsTypes } from 'src/types';

export const settingsDefaultState: reduxSettingsTypes.StateType = {
  companyImage: undefined,
  choosenMapMode: undefined,
  version: {
    'User Interface': import.meta.env.PACKAGE_VERSION,
  },
};

export const settingsReducer = (
  state = settingsDefaultState,
  action: reduxSettingsTypes.ActionType,
): reduxSettingsTypes.StateType => {
  switch (action.type) {
    case SET_CHOOSEN_MAP_MODE:
      return {
        ...state,
        choosenMapMode: action.payload,
      };

    default:
      return state;
  }
};
